<template>
	<div id="home-start-journey" class="help">
		<div class="container">
			<div class="title headline-l">
				{{ $t('homeScreen.startJourney.title') }}
			</div>
			<div class="stores d-flex justify-content-center justify-content-center">
				<store-button :version="'apple'" />
				<store-button :version="'google'" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'HomeStartJourney',
	props: {},
	components: {},
	data: () => ({}),
	created() { },
	computed: {
		...mapGetters({
			selectedLanguage: 'settings/getSelectedLanguage',
		}),
	},
	methods: {
		handleClick() {
			if (this.selectedLanguage == 'hu') {
				window.open(
					'https://data.blockben.com/FAQ/blockben_gyik.pdf',
					'_blank',
				);
			} else {
				window.open('https://data.blockben.com/FAQ/blockben_faq.pdf', '_blank');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#home-start-journey {
	background-color: #e8e8ff;
	padding-top: 55px;
	padding-bottom: 70px;
	border-bottom: 1px solid #4b2eaa80;

	.container {
		text-align: center;
		padding: 0 15px;

		.stores {
			display: flex;
			align-items: center;

			.store-button {
				&:first-child {
					margin-right: 20px;
				}
			}
		}
	}

	.title {
		color: $black;
		margin-bottom: 40px;
	}
}
</style>